import React from 'react';
import { NavigateFunction, Route } from 'react-router-dom';
import App from '~/pages/App';
//import CreateAccount from '~/pages/authentication/CreateAccount';
import Denied from '~/pages/authentication/Denied';
import Logout from '~/pages/authentication/Logout';
import NewPassword from '~/pages/authentication/NewPassword';
import ResetPassword from '~/pages/authentication/ResetPassword';
import * as HomeConnected from '~/pages/authentified/Home';
import * as FirstConnection from '~/pages/authentified/FirstConnection';
import * as ModeSoloPageConnected from '~/pages/authentified/ModeSoloPage';
import * as ModeBattlePageConnected from '~/pages/authentified/ModeBattlePage';
//import * as Battle from '~/pages/authentified/Battle';
import * as NewBattle from '~/pages/authentified/NewBattle';
//import * as BattleChallenged from '~/pages/authentified/BattleChallenged';
import * as BattleRequestPage from '~/pages/authentified/BattleRequestPage';
import * as BattleInvitationPage from '~/pages/authentified/BattleInvitationPage';
import * as BattleRecap from '~/pages/authentified/BattleRecap';
import UserTable from '~/pages/backoffice/admin/user/UserTable';
import BackOfficeLayout from '~/pages/backoffice/BackOfficeLayout';
import * as HomeBackOffice from '~/pages/backoffice/Home';
import ImAuth from '~/pages/utils/ImAuth';
import NotFound from '~/pages/utils/NotFound';
import Error from './Error';
import CreateAccountGame from '~/pages/authentication/CreateAccountGame';

export enum Role {
  Admin = 'Admin',
  Formateur = 'Formateur',
  User = 'User',
  Guest = 'Guest',
}

type RouteParam = {
  path: string;
  element: React.JSX.Element;
  rolesAuthorize: Role[];
};

export const routingDefault = (role: Role, navigate: NavigateFunction) => {
  switch (role) {
    case Role.User:
      navigate('/home');
      break;
    case Role.Admin:
    case Role.Formateur:
      navigate('/bo/home');
      break;
    default:
      navigate('/');
      break;
  }
};

// Routes à définir
// If empty array, no auth required
const routes: RouteParam[] = [
  {
    path: '/',
    element: <App />,
    rolesAuthorize: [],
  },
  {
    path: '/bo/users',
    element: (
      <BackOfficeLayout>
        <UserTable />
      </BackOfficeLayout>
    ),
    rolesAuthorize: [Role.Admin],
  },
  {
    path: '/bo/home',
    element: (
      <BackOfficeLayout>
        <HomeBackOffice.default />
      </BackOfficeLayout>
    ),
    rolesAuthorize: [Role.Admin, Role.Formateur],
  },
  {
    path: '/home/:index?',
    element: <HomeConnected.default />,
    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/first-connection',
    element: <FirstConnection.default />,
    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/mode-solo',
    element: <ModeSoloPageConnected.default />,
    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/mode-battle',
    element: <ModeBattlePageConnected.default />,
    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/mode-battle/defis',
    element: <BattleInvitationPage.default />,
    //element: <PickChallenger.default />,

    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/mode-battle/defis/:id',
    element: <NewBattle.default />,
    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/mode-battle/invitations',
    element: <BattleRequestPage.default />,
    // battleRequest
    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/mode-battle/invitations/:id',
    element: <NewBattle.default />,
    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/mode-battle/recap',
    element: <BattleRecap.default />,
    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/logout',
    element: <Logout />,
    rolesAuthorize: [],
  },
  {
    path: '/denied',
    element: <Denied />,
    rolesAuthorize: [],
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
    rolesAuthorize: [],
  },
  {
    path: '/new-password',
    element: <NewPassword />,
    rolesAuthorize: [],
  },
  {
    path: '/error',
    element: <Error />,
    rolesAuthorize: [],
  },
  {
    path: '/create-account',
    element: <CreateAccountGame />,
    rolesAuthorize: [],
  },
  {
    path: '*',
    element: <NotFound />,
    rolesAuthorize: [],
  },
];

export const renderRoutes = () => {
  return routes.map((r, i) => {
    return (
      <Route
        path={r.path}
        key={i}
        element={
          <>
            <ImAuth rolesAuthorize={r.rolesAuthorize} />
            {r.rolesAuthorize.includes(Role.Guest) ? (
              <>{r.element}</>
            ) : (
              r.element
            )}
          </>
        }
      />
    );
  });
};
